var map = {
	"./locales/ar.json": 6726,
	"./locales/cs.json": 9744,
	"./locales/da.json": 5638,
	"./locales/de.json": 9929,
	"./locales/el.json": 7498,
	"./locales/en.json": 790,
	"./locales/es.json": 8563,
	"./locales/fr-BE.json": 6888,
	"./locales/fr.json": 844,
	"./locales/he.json": 8818,
	"./locales/pt.json": 9898,
	"./locales/ru.json": 9672,
	"./locales/sv.json": 3244,
	"./locales/undefined.json": 7767,
	"./locales/vi.json": 245,
	"./locales/zh-Hant.json": 5710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5969;